import {routesMapping, Routes, createAdmission, UserPermissionsState} from '@oc/shell-core'
import {ObjectType} from '@oc/user-management'
import {RkSsmComponent} from '../Modules/RkSsmModule'
import {EmptyComponent} from '../Modules/Empty'
import {RegistrationComponent} from '../Modules/RegistrationModule'
import {UserManagementComponent, SettingsComponent} from '../Modules/UserManagementModule'
import {GlobalSettingsV2Component} from '../Modules/GlobalSettingsV2Module'
import {RkConfigComponent} from '../Modules/RkConfigModule'
import {PasswordsComponent} from '../Modules/PasswordsModule'
import {RkSystemInformationComponent} from '../Modules/RkSystemInformationModule'
import {RkRestartServiceComponent} from '../Modules/RkRestartServiceModule'
import {
    AccountRkMonitoringComponent,
    GlobalRkMonitoringComponent,
    RkMonitoringComponent
} from '../Modules/RkMonitoringModule'
import {NetworkComponent} from '../Modules/NetworkModule'
import {CustomerV2Component, DashboardV2Component} from '../Modules/CustomerV2Module'
import {CustomerComponent, EditCustomerComponent, DashboardComponent} from '../Modules/CustomerModule'
import {EquipmentV2Component} from '../Modules/EquipmentV2Module'
import {DeploymentComponent, MassDeployComponent} from '../Modules/DeploymentModule'
import {EquipmentComponent} from '../Modules/EquipmentModule'
import {MedaComponent} from '../Modules/MedaModule'
import {DataValidationComponent} from '../Modules/DataValidationModule'
import {DasDiagnosticAdaptersComponent, DasDiagnosticAdapterValuesComponent} from '../Modules/DasDiagnosticModule'
import {HwAndServicesComponent} from '../Modules/HwAndServicesModule'
import {NtpDiagnosticComponent} from '../Modules/NtpDiagnosticModule'
import {AuditTrailComponent} from '../Modules/AuditTrailModule'
import {DecommissioningComponent} from '../Modules/DecommissioningModule'
import {ConnectionCheckComponent} from '../Modules/ConnectionCheckModule'
import {TimestealersComponent} from '../Modules/TimestealersModule'
import {InsightComponent} from '../Modules/InsightModule'
import {InterfacesComponent} from '../Modules/InterfacesModule'
import {UxLabComponent} from '../Modules/UxLabModule'
import {RkMonitoringLogsComponent} from '../Modules/RkMonitoringLogsModule'
import {RkMonitoringConfigComponent} from '../Modules/RkMonitoringConfigModule'
import {OpcuaDatapointMappingComponent} from '../Modules/OpcuaDatapointMappingModule'
import {KopVersionControlComponent} from '../Modules/KopVersionControlModule'
import {LocalFlashFluidFilesComponent} from '../Modules/FlashFluidFilesModule'
import {FleetManagementComponent} from '../Modules/FleetManagementModule'

const routes: Routes = {
    withCustomerOnly: {
        customerEdit: {
            path: routesMapping.withCustomerOnly.customerEdit.path,
            module: CustomerV2Component,
            admission: createAdmission('view', 'account', ObjectType.Account, ':customerId')
        },
        viewCustomer: {
            path: routesMapping.withCustomerOnly.viewCustomer.path,
            module: EditCustomerComponent,
            admission: createAdmission('view', 'account', ObjectType.Account, ':customerId')
        },
        equipmentManagement: {
            path: routesMapping.withCustomerOnly.equipmentManagement.path,
            module: EquipmentComponent,
            admission: createAdmission('view', 'equipment', ObjectType.Account, ':customerId')
        },
        viewEquipment: {
            path: routesMapping.withCustomerOnly.viewEquipment.path,
            module: EquipmentV2Component,
            admission: createAdmission('view', 'equipment', ObjectType.Account, ':customerId')
        },
        timestealerConfiguration: {
            path: routesMapping.withCustomerOnly.timestealerConfiguration.path,
            module: TimestealersComponent,
            admission: createAdmission('view', 'timestealers', ObjectType.Account, ':customerId')
        },
        accountRkMonitoring: {
            path: routesMapping.withCustomerOnly.accountRkMonitoring.path,
            module: AccountRkMonitoringComponent,
            admission: createAdmission('view', 'rk-monitoring', ObjectType.Account, ':customerId')
        },
        insight: {
            path: routesMapping.withCustomerOnly.insight.path,
            module: InsightComponent,
            admission: createAdmission('view', 'insight', ObjectType.Account, ':customerId')
        },
        localFlashFluidFiles: {
            path: routesMapping.withCustomerAndRk.localFlashFluidFiles.path,
            module: LocalFlashFluidFilesComponent,
            admissionOr: [
                createAdmission('view', 'flash-fluid-files'),
                createAdmission('view', 'flash-fluid-files', ObjectType.Account, ':customerId')
            ]
        },
        fleetManagement: {
            path: routesMapping.withCustomerOnly.fleetManagement.path,
            module: FleetManagementComponent,
            admission: createAdmission('view', 'fleet-info', ObjectType.Account, ':customerId')
        }
    },
    withCustomerAndRk: {
        network: {
            path: routesMapping.withCustomerAndRk.network.path,
            module: NetworkComponent,
            admission: createAdmission('view', 'network', ObjectType.Account, ':customerId')
        },
        hwAndServices: {
            path: routesMapping.withCustomerAndRk.hwAndServices.path,
            module: HwAndServicesComponent,
            admission: createAdmission('view', 'machines-and-services', ObjectType.Account, ':customerId')
        },
        deploy: {
            path: routesMapping.withCustomerAndRk.deploy.path,
            module: DeploymentComponent,
            admission: createAdmission('view', 'deploy', ObjectType.Account, ':customerId')
        },
        registerRk: {
            path: routesMapping.withCustomerAndRk.registerRk.path,
            module: RegistrationComponent,
            admission: createAdmission('view', 'register', ObjectType.Account, ':customerId')
        },
        passwords: {
            path: routesMapping.withCustomerAndRk.passwords.path,
            module: PasswordsComponent,
            admission: createAdmission('view', 'passwords', ObjectType.Account, ':customerId')
        },
        meda: {
            path: routesMapping.withCustomerAndRk.meda.path,
            module: MedaComponent,
            admissionOr: [
                createAdmission('view', 'datasource', ObjectType.Account, ':customerId'),
                createAdmission('view', 'datapoint', ObjectType.Account, ':customerId'),
                createAdmission('view', 'message', ObjectType.Account, ':customerId')
            ]
        },
        interfaces: {
            path: routesMapping.withCustomerAndRk.interfaces.path,
            module: InterfacesComponent,
            admission: createAdmission('view', 'interfaces', ObjectType.Account, ':customerId')
        },
        rkConfig: {
            path: routesMapping.withCustomerAndRk.rkConfig.path,
            module: RkConfigComponent,
            admission: createAdmission('view', 'config-files', ObjectType.Account, ':customerId')
        },
        rkMonitoring: {
            path: routesMapping.withCustomerAndRk.rkMonitoring.path,
            module: RkMonitoringComponent,
            admission: createAdmission('view', 'rk-monitoring', ObjectType.Account, ':customerId')
        },
        kopVersionControl: {
            path: routesMapping.withCustomerAndRk.kopVersionControl.path,
            module: KopVersionControlComponent,
            admission: createAdmission('view', 'kop-kubernetes', ObjectType.Account, ':customerId')
        },
        rkSystemInformation: {
            path: routesMapping.withCustomerAndRk.rkSystemInformation.path,
            module: RkSystemInformationComponent,
            admission: createAdmission('view', 'rk-monitoring', ObjectType.Account, ':customerId')
        },
        rkLogs: {
            path: routesMapping.withCustomerAndRk.rkLogs.path,
            module: RkMonitoringLogsComponent,
            admission: createAdmission('view', 'rk-log', ObjectType.Account, ':customerId')
        },
        restartService: {
            path: routesMapping.withCustomerAndRk.restartService.path,
            module: RkRestartServiceComponent,
            admission: createAdmission('restart', 'rk-service', ObjectType.Account, ':customerId')
        },
        dasValidation: {
            path: routesMapping.withCustomerAndRk.dasValidation.path,
            module: DasDiagnosticAdaptersComponent
        },
        connectivityCheck: {
            path: routesMapping.withCustomerAndRk.connectivityCheck.path,
            module: ConnectionCheckComponent
        },
        dasValidationAdapterValues: {
            path: routesMapping.withCustomerAndRk.dasValidationAdapterValues.path,
            module: DasDiagnosticAdapterValuesComponent,
            admission: createAdmission('view', 'das-diagnostic', ObjectType.Account, ':customerId')
        },
        rkMonitoringConfiguration: {
            path: routesMapping.withCustomerAndRk.rkMonitoringConfiguration.path,
            module: RkMonitoringConfigComponent,
            admission: createAdmission('view', 'rk-monitoring-config', ObjectType.Account, ':customerId')
        },
        ntpValidation: {
            path: routesMapping.withCustomerAndRk.ntpValidation.path,
            module: NtpDiagnosticComponent,
            admission: createAdmission('view', 'ntp-diagnostic', ObjectType.Account, ':customerId')
        },
        decommissioning: {
            path: routesMapping.withCustomerAndRk.decommissioning.path,
            module: DecommissioningComponent,
            admission: createAdmission('view', 'decommission', ObjectType.Account, ':customerId')
        },
        rkSsm: {
            path: routesMapping.withCustomerAndRk.rkSsm.path,
            module: RkSsmComponent,
            admissionOr: [
                createAdmission('view', 'rk-ssm-command'),
                createAdmission('start', 'rk-ssm', ObjectType.Account, ':customerId')
            ]
        },
        dataValidation: {
            path: routesMapping.withCustomerAndRk.dataValidation.path,
            module: DataValidationComponent,
            admission: createAdmission('view', 'data-validation', ObjectType.Account, ':customerId')
        },
        opcuaMapping: {
            path: routesMapping.withCustomerAndRk.opcuaMapping.path,
            module: OpcuaDatapointMappingComponent,
            admission: createAdmission('view', 'opc-ua-library-handler', ObjectType.Account, ':customerId')
        },
        onboarding: {
            path: routesMapping.withCustomerAndRk.onboarding.path,
            module: EmptyComponent
        }
    },
    allOther: {
        dashboard: {
            path: routesMapping.allOther.dashboard.path,
            module: DashboardV2Component
        },
        dashboardV1: {
            path: routesMapping.allOther.dashboardV1.path,
            module: DashboardComponent
        },
        audit: {
            path: routesMapping.allOther.audit.path,
            module: AuditTrailComponent,
            customCheck: (userPermissions: UserPermissionsState): boolean => userPermissions.auditLogs.canViewSome()
        },
        globalSettings: {
            path: routesMapping.allOther.globalSettings.path,
            module: GlobalSettingsV2Component
        },
        userManagement: {
            path: routesMapping.allOther.userManagement.path,
            module: UserManagementComponent
        },
        userManagementSettings: {
            path: routesMapping.allOther.userManagementSettings.path,
            module: SettingsComponent
        },
        addCustomer: {
            path: routesMapping.allOther.addCustomer.path,
            module: CustomerComponent
        },
        logout: {
            path: routesMapping.allOther.logout.path,
            module: EmptyComponent
        },
        globalRkMonitoring: {
            path: routesMapping.allOther.globalRkMonitoring.path,
            module: GlobalRkMonitoringComponent,
            customCheck: (userPermissions: UserPermissionsState): boolean => userPermissions.rkMonitoring.canViewSome()
        },
        massDeploy: {
            path: routesMapping.allOther.massDeploy.path,
            module: MassDeployComponent,
            customCheck: (userPermissions: UserPermissionsState): boolean => userPermissions.deployments.canViewSome()
        },
        uxLab: {
            path: routesMapping.allOther.uxLab.path,
            module: UxLabComponent
        }
    }
}
export default routes
